const formatTime = time => {
  const minutes = Math.floor(time / 60)
  const seconds = time % 60

  return `${minutes}:${seconds < 10 ? '0' + seconds : seconds}`
}

export default formatTime



// WEBPACK FOOTER //
// ./src/utils/timeFormatter.js